import { apiClient } from "../config";

async function getGlobalVectorLayers(layerType?: any, params?: any) {
  const typeQuery = layerType ? `?type=${layerType}` : "";
  const res = await apiClient.get(
    `/admin/geographies/vector-layers${typeQuery}`,
    { params },
  );
  return res.data;
}

export default getGlobalVectorLayers;
